export enum CustomerCardAddressFields {
  NAME_ON_CARD = 'name',
  COUNTRY = 'country',
  ADDRESS1 = 'address1',
  ADDRESS2 = 'address2',
  CITY = 'city',
  STATE = 'state',
  POSTAL_CODE = 'postal_code',
}
export interface CustomerCardAddress {
  [CustomerCardAddressFields.NAME_ON_CARD]: string
  [CustomerCardAddressFields.COUNTRY]: string
  [CustomerCardAddressFields.ADDRESS1]: string
  [CustomerCardAddressFields.ADDRESS2]: string
  [CustomerCardAddressFields.CITY]: string
  [CustomerCardAddressFields.STATE]: string
  [CustomerCardAddressFields.POSTAL_CODE]: string
}
